import { SvgIconProps } from "@mui/material/SvgIcon";
import { FC } from "react";
// import HomeIcon from "src/assets/icons/HomeIcon";
import MedicalInformationOutlinedIcon from "@mui/icons-material/MedicalInformationOutlined";
import FeaturedPlayListIcon from "@mui/icons-material/FeaturedPlayList";
import ResourcesFilledIcon from "src/assets/icons/ResourcesFilledIcon";
import ResourcesIcon from "src/assets/icons/ResourcesIcon";
import PersonEditIcon from "src/assets/icons/PersonEditIcon";
import DocumentSearchIcon from "src/assets/icons/DocumentSearchIcon";
import ScreenSearchDesktopSharpIcon from "@mui/icons-material/ScreenSearchDesktopSharp";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import FitnessWatchIcon from "src/assets/icons/FitnessWatchIcon";
import WeightTrackerIcon from "src/assets/icons/WeightTrackerIcon";
import PersonCancelIcon from "src/assets/icons/PersonCancellationIcon";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import { Paths } from "src/constants/paths";
import { MoneyOutlined, TuneRounded } from "@mui/icons-material";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import LocalPharmacyOutlinedIcon from "@mui/icons-material/LocalPharmacyOutlined";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";

export type LinkType = {
  title: string;
  link: string;
  Icon: FC<SvgIconProps>;
  active: boolean;
};

export const adminLinks: LinkType[] = [
  {
    Icon: ResourcesFilledIcon,
    title: "Provider Resources",
    link: Paths.PROVIDER_RESOURCES,
    active: false,
  },
  {
    Icon: ResourcesIcon,
    title: "Coordinator Resources",
    link: Paths.COORDINATOR_RESOURCES,
    active: false,
  },
  {
    Icon: DocumentSearchIcon,
    title: "State Tracker",
    link: Paths.STATE_TRACKER,
    active: true,
  },
  {
    Icon: ScreenSearchDesktopSharpIcon,
    title: "Waiting Room Tracker",
    link: Paths.WAITING_ROOM_TRACKER,
    active: true,
  },
  {
    Icon: PersonSearchIcon,
    title: "Clients",
    link: Paths.CLIENTS,
    active: true,
  },
  {
    Icon: AddShoppingCartIcon,
    title: "Orders",
    link: Paths.ORDERS,
    active: true,
  },
  {
    Icon: SupportAgentIcon,
    title: "Ask Vida",
    link: Paths.CHATS,
    active: true,
  },
];

export const providerLinks: LinkType[] = [
  {
    Icon: MedicalInformationOutlinedIcon,
    title: "Provider Task Queue",
    link: Paths.PROVIDER_TASK_QUEUE,
    active: true,
  },
  {
    Icon: ResourcesFilledIcon,
    title: "Provider Resources",
    link: Paths.PROVIDER_RESOURCES,
    active: false,
  },
];

export const leadProviderLinks: LinkType[] = [
  {
    Icon: MedicalInformationOutlinedIcon,
    title: "Provider Task Queue",
    link: Paths.PROVIDER_TASK_QUEUE,
    active: true,
  },
  {
    Icon: ResourcesFilledIcon,
    title: "Provider Resources",
    link: Paths.PROVIDER_RESOURCES,
    active: false,
  },
];

export const coordinatorLinks: LinkType[] = [
  {
    Icon: FeaturedPlayListIcon,
    title: "Health Navigator Task Queue",
    link: Paths.COORDINATOR_TASK_QUEUE,
    active: true,
  },
  {
    Icon: ResourcesIcon,
    title: "Health Navigator Resources",
    link: Paths.COORDINATOR_RESOURCES,
    active: false,
  },
  {
    Icon: PersonSearchIcon,
    title: "Clients",
    link: Paths.CLIENTS,
    active: true,
  },
  {
    Icon: AddShoppingCartIcon,
    title: "Orders",
    link: Paths.ORDERS,
    active: true,
  },
  {
    Icon: ScreenSearchDesktopSharpIcon,
    title: "Waiting Room Tracker",
    link: Paths.WAITING_ROOM_TRACKER,
    active: true,
  },
  {
    Icon: PersonCancelIcon,
    title: "Cancellations",
    link: Paths.CANCELLATIONS,
    active: true,
  },
];

export const coachLinks: LinkType[] = [
  {
    Icon: PersonSearchIcon,
    title: "Clients",
    link: Paths.CLIENTS,
    active: true,
  },
  {
    Icon: ScreenSearchDesktopSharpIcon,
    title: "Waiting Room Tracker",
    link: Paths.WAITING_ROOM_TRACKER,
    active: true,
  },
  {
    Icon: FitnessWatchIcon,
    title: "Fitness and Nutrition Plans",
    link: Paths.FITNESS_AND_NUTRITION,
    active: true,
  },
];

export const developerLinks: LinkType[] = adminLinks.concat([
  {
    Icon: PersonEditIcon,
    title: "Organization",
    link: Paths.ORGANIZATION,
    active: true,
  },
  {
    Icon: FitnessWatchIcon,
    title: "Fitness and Nutrition Plans",
    link: Paths.FITNESS_AND_NUTRITION,
    active: true,
  },
  {
    Icon: WeightTrackerIcon,
    title: "Weight Tracker",
    link: Paths.DASHBOARD,
    active: false,
  },
  {
    Icon: PersonCancelIcon,
    title: "Cancellations",
    link: Paths.CANCELLATIONS,
    active: true,
  },
  {
    Icon: CardGiftcardIcon,
    title: "Promo Banners",
    link: Paths.PROMO_BANNERS,
    active: true,
  },
  {
    Icon: MoneyOutlined,
    title: "Coupons",
    link: Paths.COUPONS,
    active: true,
  },
  {
    Icon: LocalPharmacyOutlinedIcon,
    title: "Medications",
    link: Paths.MEDICATIONS,
    active: true,
  },
  {
    Icon: TuneRounded,
    title: "Titration Management",
    link: Paths.TITRATIONS_MANAGEMENT,
    active: true,
  },
]);

export const operationsLinks: LinkType[] = coordinatorLinks.concat([
  {
    Icon: PersonEditIcon,
    title: "Organization",
    link: Paths.ORGANIZATION,
    active: true,
  },
  {
    Icon: FitnessWatchIcon,
    title: "Fitness and Nutrition Plans",
    link: Paths.FITNESS_AND_NUTRITION,
    active: true,
  },
  {
    Icon: WeightTrackerIcon,
    title: "Weight Tracker",
    link: Paths.DASHBOARD,
    active: false,
  },
  {
    Icon: CardGiftcardIcon,
    title: "Promo Banners",
    link: Paths.PROMO_BANNERS,
    active: true,
  },
  {
    Icon: MoneyOutlined,
    title: "Coupons",
    link: Paths.COUPONS,
    active: true,
  },
  {
    Icon: LocalPharmacyOutlinedIcon,
    title: "Medications",
    link: Paths.MEDICATIONS,
    active: true,
  },
  {
    Icon: TuneRounded,
    title: "Titration Management",
    link: Paths.TITRATIONS_MANAGEMENT,
    active: true,
  },
]);
